"use client"

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@/components/ui/form";
import clsx from "clsx";
import {
  useFormContext
} from "react-hook-form";

export const Agree = () => {
  const form = useFormContext();

  const {
    Size 
  } = form.watch() || {}

  const isCustomizedSize = Size?.label === "customized_size"

  if (!isCustomizedSize) {
    return null
  }

  return <FormField
    control={form.control}
    name='agreement'
    render={({
      field 
    }) => {
      return (
        <FormItem className='lg_px-0 mt-6 flex flex-col items-start space-x-3 space-y-0 px-[15px] pb-5'>
          <div className='flex gap-3'>
            <FormControl>
              <button type='button' 
                className={clsx(
                  " w-5 h-5 ", "border-1 border-solid border-80583F",
                  field.value ? "bg-80583F" : "",
                  "flex-none flex items-center justify-center",
                )}
                onClick={() => {
                  field.onChange(!field.value);
                }}
              >
                {
                  field.value ? <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='14'
                    height='12'
                    fill='none'
                    viewBox='0 0 14 12'
                  >
                    <path
                      stroke='#fff'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='1.5'
                      d='M13 1 4.6 11 1 7.25'
                    />
                  </svg> : null
                }
              </button>
            </FormControl>
            <div className='space-y-1 text-sm leading-none'>
              <FormLabel className='lg_text-[14px] cursor-pointer text-sm'>
                              I acknowledge that I confirm and agree to the following regarding the terms of the Custom Sizing Terms and Conditions:
              </FormLabel>
  
            </div>
  
          </div>
  
          <FormMessage id='agreement' />
  
  
          <ul className='lg_text-sm !mt-[10px]  text-[15px]'>
            <li className='relative pl-[38px]'>
              <div className='absolute left-3 top-0 h-5 w-6 text-center'>
                ·
              </div>
              <span>
                Custom Dresses are NOT eligible for return or exchange.
              </span>
            </li>
            <li className='relative pl-[38px]'>
              <div className='absolute left-3 top-0 h-5 w-6 text-center'>
                ·
              </div>
              <span>
                          Before finalizing your order, please double-check the hand-measured dimensions you provide.
              </span>
            </li>
            <li className='relative pl-[38px]'>
              <div className='absolute left-3 top-0 h-5 w-6 text-center'>
                ·
              </div>
              <span>
                          Minor variations may occur since the dress is handmade, so it may not appear exactly as it does in the displayed image.
              </span>
            </li>
          </ul>
        </FormItem>
      )
    }}
  />
}
